<template>
  <div>
    <h4>业务线：{{ tabOrg }}</h4>
    <h4>专题标题：{{ tabName }}</h4>
    <div>
      <a-form :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
        <a-row>
          <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
            <a-form-item label="文章标题">
              <a-input v-model="searchForm.article_title" allowClear placeholder="请输入文章标题" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
            <a-form-item label="文章ID">
              <a-input-number :min="0" :precision="0" v-model="searchForm.article_id" allowClear placeholder="请输入文章ID" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
            <a-form-item label="发布时间">
              <v-range-picker v-model="times" @change="onChange" :placeholder="['开始时间', '结束时间']" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 搜索按钮 -->
    <div class="flex-sb">
      <div>
        <a-button type="primary" icon="plus-circle" style="margin-right:10px;" @click="handleAdd">手动关联</a-button>
        <a-button type="primary" icon="reload" ghost @click="syncList">关联同步</a-button>
      </div>
      <div>
        <a-button type="primary" icon="search" style="margin-right: 20px;" @click="search">查询</a-button>
        <a-button type="primary" icon="delete" ghost @click="handleClear">清空</a-button>
      </div>
    </div>
    <!-- 表格 -->
    <a-table row-key="id" :columns="columnsArticle" :loading="loading" :data-source="data" :pagination="pagination" style="margin-top: 20px" @change="handleTableChange">
      <template slot="title" slot-scope="text">
        <a v-if="text.pc_detail_url" :href="text.pc_detail_url" target="_blank">{{ text.title }}</a>
        <span v-else>{{ text.title }}</span>
      </template>
      <template slot="typeid" slot-scope="text">
        {{ showListName(text, 'classify') }}
      </template>
      <template slot="add_person_name" slot-scope="text, record">
        {{ `${text}(${record.article.add_person})` }}
      </template>
      <template slot="operator" slot-scope="text, record">
        <a-button size="small" type="link" style="margin-left: 20px" @click="del(record)">取消关联</a-button>
      </template>
    </a-table>

    <!-- 添加公司 -->
    <Addrelevancy v-model="visible" :isEdit="isEdit" @handleOver="getList" />
  </div>
</template>
<script>
import { ref, reactive, onMounted, toRefs, getCurrentInstance, computed } from '@vue/composition-api'
import { columnsArticle, searchFormArticle } from './business/filialeList'
import { strategyCommand } from './business/tableList'
import pagination from '@/composables/pagination'
import Addrelevancy from './components/Addrelevancy'
import api from '@/api/'
import store from '@/store/'

export default {
  components: { Addrelevancy },
  setup(props, { root }) {
    // 获取当前实例
    const _this = getCurrentInstance()
    const state = reactive({
      searchForm: { ...searchFormArticle },
      columnsArticle,
      times: [],
      tabName: _this.$route.query.title,
      tabOrg: _this.$route.query.org,
      topic: _this.$route.params.id
    })

    onMounted(async () => {
      await methods.getArticleClassify()
      await methods.syncList()
    })

    const methods = {
      async syncList() {
        _this.loading = true
        const res = await api.batchTopic({ id: state.topic })
        if (res.code === '000000') {
          _this.$message.success('同步成功~')
          this.getList()
        }
      },
      onChange(date, dateString) {
        state.searchForm.start_date = dateString[0]
        state.searchForm.end_date = dateString[1]
      },
      handleClear() {
        state.searchForm = { ...searchFormArticle }
        state.times = []
        this.search()
      },
      search() {
        _this.pagination.current = 1
        this.getList()
      },
      async getList() {
        _this.loading = true
        const res = await api.listTopic({
          topic: _this.topic,
          ..._this.searchForm,
          page: _this.pagination.current,
          per_page: _this.pagination.pageSize
        })
        const { topic_article, pagination } = res.data
        _this.data = topic_article
        _this.pagination.total = pagination.total
        _this.loading = false
      },

      async inputDebounce(sort, data) {
        const res = await api.updateLink(data)
        if (_this.$validate(res)) {
          _this.$message.success('操作成功~')
        }
      },
      // 表格变化事件
      handleTableCommand(type, ...arg) {
        strategyCommand[type].call(_this, ...arg)
      },
      async del(data) {
        this.$confirm({
          title: '是否确定取消关联？',
          okText: '确认',
          cancelText: '取消',
          onOk: async () => {
            const res = await api.createTopic({ topic: _this.topic, article: [data.article.id] })
            if (_this.$validate(res)) {
              _this.$message.success('取消关联成功~')
              _this.getList()
            }
          }
        })
      },
      handleAdd() {
        _this.visible = true
        _this.isEdit = false
      },
      // 获取文章分类
      async getArticleClassify() {
        const res = await api.listClassify()
          state.classifyList = res?.data?.articleType
      },
      showListName(id, type) {
        switch (type) {
          case 'classify':
            const classify = state.classifyList.filter(item => Number(item.id) === Number(id))[0]
            return (classify && classify.type_name) || '--'
          case 'platform':
            const platform = state.platformList.filter(item => Number(item.id) === Number(id))[0]
            return (platform && platform.name) || '--'
        }
      }
    }

    return {
      ...toRefs(state),
      ...pagination(),
      ...methods
    }
  }
}
</script>
